import { render, staticRenderFns } from "./AppBarItemButton.vue?vue&type=template&id=1ad9519b"
import script from "./AppBarItemButton.vue?vue&type=script&lang=js"
export * from "./AppBarItemButton.vue?vue&type=script&lang=js"
import style0 from "./AppBarItemButton.vue?vue&type=style&index=0&id=1ad9519b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports